import { render, staticRenderFns } from "./flowup.vue?vue&type=template&id=e0ef74d2&scoped=true&"
import script from "./flowup.vue?vue&type=script&lang=js&"
export * from "./flowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ef74d2",
  null
  
)

export default component.exports